import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ed909a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "template-dialog-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_custom = _resolveComponent("ui-custom")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_custom, {
      modelValue: _ctx.list,
      pageName: _ctx.pageName,
      onSubmit: _ctx.saveEvent
    }, null, 8, ["modelValue", "pageName", "onSubmit"])
  ]))
}